import React from 'react';
import 'react-dates/lib/css/_datepicker.css';
import { Button, Input, Select } from 'semantic-ui-react';
import EventService from '../../../services/api/eventService';
import { errorInput, eventSlugnameTrim, formSelectService } from '../../../components/helpers';
import { encuentroAgeNotice, isEncuentroEventName } from './components/reservationExtraInfo';
import useRememberCredentials from '../../../components/helpers/useRememberCredentials';
import RememberCredentialsCheckbox from '../../../components/helpers/RememberCredentialsCheckbox';
import Swal from 'sweetalert2';
import { habeasData } from '../../../components/helpers/habeasData';
import { withRouter } from 'react-router-dom';
import styled from '@emotion/styled';
import { screenSizes } from 'src/assets/styles/Literals';
import { ServiceContainer } from 'src/assets/styles/components/reservation';
import { RegistrationForm } from 'src/assets/styles/components/Registration';

const StepCheckContainer = styled.div`
  .reservation-step-check-service {
    h1 {
      font-size: 2.5rem;
      color: #2c3e50;
      margin-bottom: 1rem;
      text-align: center;
    }

    h2 {
      font-size: 1.5rem;
      color: #34495e;
      margin-bottom: 2rem;
      text-align: center;
      font-weight: 400;
    }

    p {
      color: #7f8c8d;
      line-height: 1.6;
      margin-bottom: 1rem;
      text-align: center;

      strong {
        color: #2c3e50;
        font-weight: 600;
      }
    }
  }

  .reservation-step-check-form {
    max-width: 600px;
    margin: 0 auto;
    padding: 2rem;
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

    label {
      display: block;
      font-size: 1.5rem;
      color: #2c3e50;
      margin-bottom: 1.5rem;
      text-align: center;
    }

    label[for='remember-credentials'] {
      font-size: 0.875rem;
      font-weight: 400;
      margin-bottom: 1rem;
      text-align: left;
    }

    .ui.input {
      width: 100%;
      margin-bottom: 1rem;

      input {
        width: 100%;
        padding: 12px;
        border: 1px solid #ddd;
        border-radius: 8px;
        font-size: 1rem;
        transition: all 0.3s ease;

        &:focus {
          border-color: #3498db;
          box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
        }

        &.error {
          border-color: #e74c3c;
          background-color: #fdf0ed;
        }
      }
    }

    .ui.button {
      width: 100%;
      background: #3498db;
      color: white;
      padding: 12px 24px;
      border-radius: 8px;
      font-weight: 500;
      transition: all 0.2s ease;
      margin-top: 1.5rem;

      &:hover {
        background: #2980b9;
        transform: translateY(-1px);
      }

      &:disabled {
        background: #bdc3c7;
        cursor: not-allowed;
      }
    }

    h4 {
      color: #e74c3c;
      text-align: center;
      margin: 1rem 0;
    }
  }

  .change-event {
    text-align: center;
    margin: 1rem 0;
    color: #3498db;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      color: #2980b9;
      text-decoration: underline;
    }
  }

  .event-selector {
    margin: 1rem 0;
    padding: 1rem;
    background: #f8f9fa;
    border-radius: 8px;

    .ui.selection.dropdown {
      width: 100%;
      padding: 12px;
      border: 1px solid #ddd;
      border-radius: 8px;
      font-size: 1rem;
      transition: all 0.3s ease;

      &:hover {
        border-color: #3498db;
      }
    }
  }

  @media (max-width: ${screenSizes.tablet}) {
    .reservation-step-check-service {
      h1 {
        font-size: 2rem;
      }

      h2 {
        font-size: 1.25rem;
      }
    }

    .reservation-step-check-form {
      padding: 1rem;
    }
  }
`;

const ReservationStepCheck = (props) => {
  const {
    inputs,
    setInputs,
    defaulteventSlugname,
    isAudPpal,
    services,
    loading,
    set_loading,
    checkAuditoriumGuest,
  } = props;
  const [errorInputs, set_errorInputs] = React.useState({});
  const [changeEvent, set_changeEvent] = React.useState(false);
  const [previousEventsNames, set_previousEventsNames] = React.useState([]);
  const { rememberCredentials, setRememberCredentials, persistCredentials } =
    useRememberCredentials({ setInputs });

  React.useEffect(() => {
    getPreviousEventNames();
  }, []);

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (
      params.get('identification') &&
      params.get('phone') &&
      inputs.identification &&
      inputs.phone
    )
      enterReservation({ preventDefault: () => {} });
  }, [inputs.identification, inputs.phone]);

  const verifyForm = () => {
    let mandatoryInputs = ['identification', 'phone'];
    let errorInputsCheck = {};

    mandatoryInputs.forEach((input) => {
      errorInputsCheck = errorInput({
        errorInputs: errorInputsCheck,
        input: { name: input, value: inputs[input] },
      });
    });

    if (inputs['identification'] && inputs['identification'].length <= 5) {
      errorInputsCheck = errorInput({
        errorInputs: errorInputsCheck,
        input: {
          name: 'identification',
          value: inputs['identification'].length >= 5,
        },
      });
    }

    if (inputs['phone'] && inputs['phone'].length <= 10) {
      errorInputsCheck = errorInput({
        errorInputs: errorInputsCheck,
        input: {
          name: 'phone',
          value: inputs['phone'].length >= 10,
        },
      });
    }

    set_errorInputs(errorInputsCheck);
    return Object.values(errorInputsCheck).includes(true);
  };

  const enterReservation = async (e) => {
    e.preventDefault();
    if (verifyForm()) return;
    if (Object.keys(services).length === 0 && !loading) {
      set_changeEvent(true);
      return Swal.fire(
        'No hay eventos disponibles en este momento',
        'Verifica el enlace, o selecciona uno de los eventos disponibles',
        'warning'
      );
    }

    persistCredentials({
      identification: inputs.identification,
      phone: inputs.phone,
    });

    await checkAuditoriumGuest({
      identification: inputs.identification,
      phone: inputs.phone,
      updateStep: true,
    });
  };

  const handleInputs = (event) => {
    const { name, value } = event.target;
    setInputs({ ...inputs, [name]: value });
    set_errorInputs((prev) => ({ ...prev, [name]: false }));
  };

  const selectHandle = (a, { value }) => {
    if (value === 'Servicio_del_fin_de_semana') value = 'Auditorio_Principal';
    props.history.push(`/servicio/reservacion?event=${value}`);
    setInputs({ ...inputs, eventSlugname: value });
    set_changeEvent(false);
  };

  const getPreviousEventNames = () => {
    set_loading(true);
    EventService.getEventsNames({ postDays: 360 })
      .then((response) => {
        set_loading(false);
        if (response.data.success) {
          set_previousEventsNames(response.data.eventsNames);
        }
      })
      .catch((err) => {
        set_loading(false);
      });
  };

  return (
    <StepCheckContainer>
      <ServiceContainer className="reservation-step-check-service">
        <h1>¡Bienvenido!</h1>
        <h2>
          Regístrate en un{isAudPpal ? 'a' : 'o'} de nuestr{isAudPpal ? 'a' : 'o'}s{' '}
          {isAudPpal ? 'reuniones' : 'eventos'}
        </h2>
        <RegistrationForm
          className="reservation-step-check-form"
          onSubmit={(e) => enterReservation(e)}
        >
          <label>Escribe tus datos</label>
          {!!defaulteventSlugname() && !isAudPpal && (
            <p>
              Reservando para <strong>{eventSlugnameTrim(defaulteventSlugname())}</strong>
            </p>
          )}
          {isAudPpal && (
            <>
              <p>
                Reservando para <strong>servicio del fin de semana</strong>
              </p>
              <p>
                Si deseas asistir a nuestro Campus Medellín para servicio del fin de semana, ya no
                tienes que registrarte.
              </p>
            </>
          )}
          {!changeEvent ? (
            <p className="change-event" onClick={() => set_changeEvent(true)}>
              ¿Quieres reservar para otro evento?
            </p>
          ) : (
            <div className="event-selector">
              {formSelectService({
                Select,
                label: 'Evento a reservar',
                name: 'eventSlugname',
                handler: selectHandle,
                value: inputs.eventSlugname,
                options: ['Servicio_del_fin_de_semana', ...previousEventsNames],
              })}
            </div>
          )}
          {Object.values(errorInputs || {}).includes(true) && (
            <h4>Por favor verifica los campos en rojo.</h4>
          )}
          {defaulteventSlugname()?.toLowerCase()?.includes('camp') && (
            <p>Llena esto con la información del campista, de la persona que asistirá al Camp.</p>
          )}
          {defaulteventSlugname()?.toLowerCase()?.includes('bauti') && (
            <p>La inscripción al bautismo está disponible solo para personas de 13 años o más.</p>
          )}
          {isEncuentroEventName(defaulteventSlugname()) && (
            <p>{encuentroAgeNotice(defaulteventSlugname())}</p>
          )}
          <Input
            onChange={handleInputs}
            name={'identification'}
            value={inputs.identification}
            type="number"
            placeholder="Identificación"
            id="identification"
            className={`Registration__input Registration__input-${'identification'} ${
              errorInputs['identification'] ? 'error' : ''
            }`}
          />
          <Input
            placeholder="Celular"
            id="phone"
            name={'phone'}
            type="number"
            className={`Registration__input Registration__input-${'phone'} ${
              errorInputs['phone'] ? 'error' : ''
            }`}
            value={inputs.phone}
            onChange={handleInputs}
          />
          <RememberCredentialsCheckbox
            checked={rememberCredentials}
            onChange={setRememberCredentials}
          />
          {habeasData}
          <Button primary disabled={loading} type="submit">
            Entrar
          </Button>
        </RegistrationForm>
      </ServiceContainer>
    </StepCheckContainer>
  );
};

export default withRouter(ReservationStepCheck);
